import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Modules
import { OnboardingRoutingModule } from '@app/onboarding/onboarding-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { UploaderModule } from '@app/uploader/uploader.module';
import { LayoutModule } from '@app/layout/layout.module';
import { TagsModule } from './../tags/tags.module';

// components
import { AssignedSkillsComponent } from '@app/onboarding/components/assigned-skills/assigned-skills.component';
import { HmmTagPickerComponent } from '@app/onboarding/components/hmm/hmm-tag-picker/hmm-tag-picker.component';
import { TagDropdownComponent } from '@app/onboarding/components/hmm/tag-dropdown/tag-dropdown.component';
import { OnboardingFooterComponent } from '@app/onboarding/components/onboarding-footer/onboarding-footer.component';
import { OnboardingViewComponent } from '@app/onboarding/components/onboarding-view/onboarding-view.component';
import { ContentExpanderComponent } from '@app/onboarding/components/resume-parsing/content-expander/content-expander.component';
import { ExperienceComponent } from '@app/onboarding/components/resume-parsing/experience/experience.component';
import { ResumeParsingComponent } from '@app/onboarding/components/resume-parsing/resume-parsing.component';
import { RoleSearchComponent } from '@app/onboarding/components/role-select/role-search/role-search.component';
import { RoleSelectComponent } from '@app/onboarding/components/role-select/role-select.component';
import { RoleSelectItemsComponent } from '@app/onboarding/components/role-select/role-select-items/role-select-items.component';
import { SkillsComponent } from '@app/onboarding/components/skills/skills.component';
import { SkillSearchComponent } from '@app/onboarding/components/skills/skill-search/skill-search.component';
import { SkillSelectItemsComponent } from '@app/onboarding/components/skills/skill-select-items/skill-select-items.component';
import { SkillTypeaheadItemComponent } from '@app/onboarding/components/skills/skill-search/skill-typeahead-item/skill-typeahead-item.component';
import { StartLearningComponent } from '@app/onboarding/components/startlearning/startlearning.component';
import { TrackerComponent } from '@app/onboarding/components/tracker/tracker.component';
import { WelcomeComponent } from '@app/onboarding/components/welcome/welcome.component';
import { ReviewSkillsComponent } from './components/review-skills/review-skills.component';
import { AreYouSureRatingModalComponent } from './components/are-you-sure-rating-modal/are-you-sure-rating-modal.component';
import { RoleTileComponent } from './components/role-select/role-tile/role-tile.component';
import { FirstQueueComponent } from './components/first-queue/first-queue.component';
import { FirstPathwayComponent } from './components/first-pathway/first-pathway.component';

@NgModule({
  declarations: [
    AssignedSkillsComponent,
    HmmTagPickerComponent,
    TagDropdownComponent,
    OnboardingFooterComponent,
    OnboardingViewComponent,
    ContentExpanderComponent,
    ExperienceComponent,
    ResumeParsingComponent,
    RoleSearchComponent,
    RoleSelectComponent,
    RoleSelectItemsComponent,
    SkillsComponent,
    SkillSearchComponent,
    SkillSelectItemsComponent,
    SkillTypeaheadItemComponent,
    StartLearningComponent,
    TrackerComponent,
    WelcomeComponent,
    ReviewSkillsComponent,
    AreYouSureRatingModalComponent,
    RoleTileComponent,
    FirstQueueComponent,
    FirstPathwayComponent,
  ],
  imports: [
    CommonModule,
    OnboardingRoutingModule,
    SharedModule,
    TagsModule,
    LayoutModule,
    NgbAccordionModule,
    UploaderModule,
  ],
  providers: [],
})
export class OnboardingModule {}
